var _variants;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import _styled from '@emotion/styled/base';
import { css } from '@emotion/react';
import { Spacing, Size, FieldHeight } from '@tablekit/theme';
import { margin, variant, getThemeValue, mediaQuery } from '@tablekit/utils';
import { itemThemeNamespace, itemClassicTheme } from '../themes.js';
import { ItemInteractionState, ItemBorderPosition } from '../types.js';

function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var borderWidth = '2px';
var focusOutlineRadius = '6px'; // needs to be here to prevent circular dependencies

var BeforeAfterBase = _styled("span", process.env.NODE_ENV === "production" ? {
  target: "ejaur842"
} : {
  target: "ejaur842",
  label: "BeforeAfterBase"
})(process.env.NODE_ENV === "production" ? {
  name: "12o7d5c",
  styles: "display:flex;justify-content:center;align-items:center;flex-shrink:0"
} : {
  name: "12o7d5c",
  styles: "display:flex;justify-content:center;align-items:center;flex-shrink:0",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});

var ElementBefore = /*#__PURE__*/_styled(BeforeAfterBase, process.env.NODE_ENV === "production" ? {
  target: "ejaur841"
} : {
  target: "ejaur841",
  label: "ElementBefore"
})(function (_ref) {
  var hasOnlyIcon = _ref.hasOnlyIcon,
      theme = _ref.theme;
  return hasOnlyIcon ? '' : margin({
    right: Spacing.L2
  })({
    theme: theme
  });
}, ";");

var ElementAfter = /*#__PURE__*/_styled(BeforeAfterBase, process.env.NODE_ENV === "production" ? {
  target: "ejaur840"
} : {
  target: "ejaur840",
  label: "ElementAfter"
})(function (_ref2) {
  var hasOnlyIcon = _ref2.hasOnlyIcon,
      theme = _ref2.theme;
  return hasOnlyIcon ? '' : margin({
    left: Spacing.L2
  })({
    theme: theme
  });
}, ";");

var interactionStates = variant({
  prop: 'interactionState',
  key: "".concat(itemThemeNamespace, ".interactionStates"),
  default: ItemInteractionState.Default,
  variants: {
    default: function _default(props) {
      return /*#__PURE__*/css("display:flex;background-color:", getThemeValue("".concat(itemThemeNamespace, ".default.background"), itemClassicTheme.default.background)(props), ";color:", getThemeValue("".concat(itemThemeNamespace, ".default.textColor"), itemClassicTheme.default.textColor)(props), ";& ", ElementBefore, ",& ", ElementAfter, "{color:", getThemeValue("".concat(itemThemeNamespace, ".default.beforeAfterColor"), itemClassicTheme.default.beforeAfterColor)(props), ";}&:focus{box-shadow:0 0 0 2px ", props.theme.colors.focusOutline, " inset;border-radius:", focusOutlineRadius, ";}&:hover{background-color:", getThemeValue("".concat(itemThemeNamespace, ".default.hoverBackground"), itemClassicTheme.default.hoverBackground)(props), ";color:", getThemeValue("".concat(itemThemeNamespace, ".default.hoverTextColor"), itemClassicTheme.default.hoverTextColor)(props), ";& ", ElementBefore, ",& ", ElementAfter, "{color:", getThemeValue("".concat(itemThemeNamespace, ".default.beforeAfterColor"), itemClassicTheme.default.beforeAfterColor)(props), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:interactionStates;"));
    },
    hidden: process.env.NODE_ENV === "production" ? {
      name: "eivff4",
      styles: "display:none"
    } : {
      name: "1mkqgn7-hidden",
      styles: "display:none;label:hidden;",
      toString: _EMOTION_STRINGIFIED_CSS_ERROR__
    },
    selected: function selected(upperProps) {
      return /*#__PURE__*/css("display:flex;background-color:", getThemeValue("".concat(itemThemeNamespace, ".selected.background"), itemClassicTheme.selected.background)(upperProps), ";color:", getThemeValue("".concat(itemThemeNamespace, ".selected.textColor"), itemClassicTheme.selected.textColor)(upperProps), ";& ", ElementBefore, ",& ", ElementAfter, "{color:", getThemeValue("".concat(itemThemeNamespace, ".selected.beforeAfterColor"), itemClassicTheme.selected.beforeAfterColor)(upperProps), ";}&:focus{box-shadow:0 0 0 2px ", upperProps.theme.colors.focusOutline, " inset;border-radius:", focusOutlineRadius, ";}", variant({
        prop: 'borderPosition',
        default: ItemBorderPosition.Left,
        variants: {
          left: function left(props) {
            return /*#__PURE__*/css("box-shadow:inset ", borderWidth, " 0px ", getThemeValue("".concat(itemThemeNamespace, ".selected.borderColor"), itemClassicTheme.selected.borderColor)(props), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:interactionStates;"));
          },
          right: function right(props) {
            return /*#__PURE__*/css("box-shadow:inset -", borderWidth, " 0px ", getThemeValue("".concat(itemThemeNamespace, ".selected.borderColor"), itemClassicTheme.selected.borderColor)(props), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:interactionStates;"));
          },
          top: function top(props) {
            return /*#__PURE__*/css("box-shadow:inset 0px ", borderWidth, " ", getThemeValue("".concat(itemThemeNamespace, ".selected.borderColor"), itemClassicTheme.selected.borderColor)(props), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:interactionStates;"));
          },
          bottom: function bottom(props) {
            return /*#__PURE__*/css("box-shadow:inset 0px -", borderWidth, " ", getThemeValue("".concat(itemThemeNamespace, ".selected.borderColor"), itemClassicTheme.selected.borderColor)(props), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:interactionStates;"));
          }
        }
      })(upperProps), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:interactionStates;"));
    },
    disabled: function disabled(props) {
      return /*#__PURE__*/css("display:flex;opacity:0.5;color:", getThemeValue("".concat(itemThemeNamespace, ".disabled.textColor"), itemClassicTheme.disabled.textColor)(props), ";& ", ElementBefore, ",& ", ElementAfter, "{color:", getThemeValue("".concat(itemThemeNamespace, ".disabled.beforeAfterColor"), itemClassicTheme.disabled.beforeAfterColor)(props), ";}cursor:not-allowed;&:hover{color:", getThemeValue("".concat(itemThemeNamespace, ".disabled.textColor"), itemClassicTheme.disabled.textColor)(props), ";& ", ElementBefore, ",& ", ElementAfter, "{color:", getThemeValue("".concat(itemThemeNamespace, ".disabled.beforeAfterColor"), itemClassicTheme.disabled.beforeAfterColor)(props), ";}}" + (process.env.NODE_ENV === "production" ? "" : ";label:interactionStates;"));
    }
  }
});
var getSizeStyle = variant({
  prop: 'size',
  default: Size.Regular,
  variants: (_variants = {}, _defineProperty(_variants, Size.Regular, function (props) {
    return /*#__PURE__*/css("height:", mediaQuery('height', function (value) {
      return value || FieldHeight.Regular;
    })(props), ";min-height:", FieldHeight.Regular, ";padding:0 ", Spacing.L3, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:getSizeStyle;"));
  }), _defineProperty(_variants, Size.Large, function (props) {
    return /*#__PURE__*/css("height:", mediaQuery('height', function (value) {
      return value || FieldHeight.Large;
    })(props), ";min-height:", FieldHeight.Large, ";padding:0 ", Spacing.L4, ";" + (process.env.NODE_ENV === "production" ? "" : ";label:getSizeStyle;"));
  }), _variants)
});
export { ElementAfter, ElementBefore, borderWidth, focusOutlineRadius, getSizeStyle, interactionStates };
